import React from 'react';

const NoBillingDetailFound = () => (
    <div style={{ textAlign: 'center', padding: '2rem' }}>
        <h2>No Billing Details Found</h2>
        <p>There are currently no billing details available for this payroll.</p>
    </div>
);

export default NoBillingDetailFound;